import { render, staticRenderFns } from "./document-filter.vue?vue&type=template&id=77c49a29"
import script from "./document-filter.vue?vue&type=script&setup=true&lang=js"
export * from "./document-filter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports